export default class Main{
    
    constructor() {
        this._init();
    }
    
    _init(){
        const lang = 
            (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage ||
            window.navigator.browserLanguage;
        
        if(lang==='en' || lang==='en-US'){
            location.href = '/en/';
        }
        else{
            location.href = '/ja/';
        }
    }
}
